document.addEventListener('DOMContentLoaded', () => {
  const articleBody = document.querySelector('[data-astroca-link-cards]');

  if (!articleBody) return;

  const cleanText = (text) => {
    return text
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .trim();
  };

  const candidates = Array.from(
    articleBody.querySelectorAll('p, div')
  ).filter((element) => {
    if (element.querySelector(':scope > p, :scope > div')) {
      return false;
    }

    const text = cleanText(element.textContent);

    const isAbsoluteUrl = /^https?:\/\/\S+$/.test(text);
    const isAstrocaRelativeUrl =
      /^\/blogs\/astroca-journal\/\S+$/.test(text);

    return isAbsoluteUrl || isAstrocaRelativeUrl;
  });

  candidates.forEach(async (element) => {
    const rawText = cleanText(element.textContent);

    let targetUrl;

    try {
      const anchor = element.querySelector('a[href]');

      targetUrl = new URL(
        anchor ? anchor.href : rawText,
        window.location.origin
      );
    } catch {
      return;
    }

    const currentHost =
      window.location.hostname.replace(/^www\./, '');

    const targetHost =
      targetUrl.hostname.replace(/^www\./, '');

    const isAstrocaJournal =
      targetUrl.pathname.startsWith('/blogs/astroca-journal/') &&
      (
        currentHost === targetHost ||
        targetHost === 'astroca.jp'
      );

    if (!isAstrocaJournal) return;

    try {
      const response = await fetch(targetUrl.pathname);

      if (!response.ok) return;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const title =
        doc.querySelector('meta[property="og:title"]')?.content ||
        doc.querySelector('h1')?.textContent?.trim() ||
        doc.title;

      const description =
        doc.querySelector('meta[property="og:description"]')?.content ||
        doc.querySelector('meta[name="description"]')?.content ||
        '';

      const image =
        doc.querySelector('meta[property="og:image"]')?.content ||
        doc.querySelector('meta[name="twitter:image"]')?.content ||
        '';

      const card = document.createElement('a');
      card.className = 'astroca-link-card';
      card.href = targetUrl.href;

      if (image) {
        const imageWrapper = document.createElement('div');
        imageWrapper.className = 'astroca-link-card__image-wrapper';

        const img = document.createElement('img');
        img.className = 'astroca-link-card__image';
        img.src = new URL(image, targetUrl.href).href;
        img.alt = '';
        img.loading = 'lazy';

        imageWrapper.appendChild(img);
        card.appendChild(imageWrapper);
      }

      const content = document.createElement('div');
      content.className = 'astroca-link-card__content';

      const label = document.createElement('span');
      label.className = 'astroca-link-card__label';
      label.textContent = '関連記事';

      const titleElement = document.createElement('strong');
      titleElement.className = 'astroca-link-card__title';
      titleElement.textContent = title;

      content.appendChild(label);
      content.appendChild(titleElement);

      if (description) {
        const descriptionElement = document.createElement('span');
        descriptionElement.className = 'astroca-link-card__description';
        descriptionElement.textContent = description;

        content.appendChild(descriptionElement);
      }

      const site = document.createElement('span');
      site.className = 'astroca-link-card__site';
      site.textContent = 'ASTROCA Journal';

      content.appendChild(site);
      card.appendChild(content);

      element.replaceWith(card);
    } catch (error) {
      console.error('ASTROCA Link Card Error:', error);
    }
  });
});